<template>
    <a
        v-if="urlFormatted.length > 0"
        :href="urlFormatted"
        target="_blank"
        class="avatar-listing-link"
    >
        <CompassUser :size="size" :firstname="firstname" :lastname="lastname" :showCaption="false">
            <CompassAvatar
                :colorType="colorType"
                :size="size"
                :initials="initials"
                :type="avatarType"
            />
        </CompassUser>
    </a>
    <span v-else>
        <CompassUser :size="size" :firstname="firstname" :lastname="lastname" :showCaption="false">
            <CompassAvatar
                :colorType="colorType"
                :size="size"
                :initials="initials"
                :type="avatarType"
            />
        </CompassUser>
    </span>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'extra-small',
        },
        id: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        firstname: {
            type: String,
            required: true,
        },
        lastname: {
            type: String,
            required: true,
        },
        colorType: {
            type: String,
            required: true,
        },
        initials: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            urlFormatted: '',
            avatarType: 'default',
        };
    },
    created() {
        switch (this.type) {
            case 'corp':
                this.avatarType = 'company';
                break;
            case 'group':
                this.avatarType = 'team';
                break;
            case 'staff':
                this.avatarType = 'default';
                this.urlFormatted = `/staff/${this.id}`;
                break;
            default:
                this.avatarType = 'default';
                this.urlFormatted = '';
        }
    },
};
</script>

<style lang="scss" scoped>
.avatar-listing-link {
    &:hover {
        :deep(.compass-user__name) {
            color: var(--colors-common-text-standard-active);
        }
    }
}
</style>
